var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button capitalize pointer",class:{
        'button--default': !_vm.customClass,
        'button--hover': _vm.hasHover
    }},_vm.$listeners),[_vm._t("button__icon"),_vm._t("button__text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }